import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Router} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {MonoTypeOperatorFunction, pipe} from 'rxjs';
import {takeUntil, tap} from 'rxjs/operators';
import {OnDestroySubject} from '../../../data/model';
import {loadQualifyingCatalogIds} from '../../catalog/catalog.actions';
import {selectFirstCatalogId} from '../../catalog/catalog.selectors';
import {filterUndefined} from '../../service';

/**
 * Entry component for the commerce module. This component acts like a resolver to load available
 * catalog ids for the registration context.
 */
@Component({
  selector: 'app-entry',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EntryComponent extends OnDestroySubject implements OnInit {
  constructor(
    private store: Store,
    private router: Router,
  ) {
    super();
    this.store.dispatch(loadQualifyingCatalogIds());
  }

  ngOnInit(): void {
    this.subscribeToCurrentCatalog();
  }

  private subscribeToCurrentCatalog(): void {
    this.store
      .pipe(
        select(selectFirstCatalogId),
        filterUndefined(),
        this.redirectToCatalog(),
        takeUntil(this.onDestroy),
      )
      .subscribe();
  }

  private redirectToCatalog(): MonoTypeOperatorFunction<
    string | null | undefined
  > {
    return pipe(
      tap({
        next: (catalogId: string | null | undefined): void => {
          if (catalogId) {
            this.router.navigate([
              {outlets: {commerceElement: `commerce/catalog/${catalogId}`}},
            ]);
          } else {
            this.router.navigate([{outlets: {commerceElement: 'no-add-ons'}}]);
          }
        },
      }),
    );
  }
}
